import {
  DownloadResponseSchema, LibraryResponseSchema, LibraryUploadSchema, LibraryUploadsResponseSchema, type ToLibraryRequest,
} from '@couch/shared';
import { z } from 'zod';
import { empty, json } from './client';

const seg = encodeURIComponent;

/** The model library in the user's bucket (doc 75). */
export const libraryApi = {
  list: () => json(LibraryResponseSchema, 'GET', '/storage/models'),
  toLibrary: (body: ToLibraryRequest) => json(z.object({ upload: LibraryUploadSchema }), 'POST', '/storage/models', body),
  uploads: () => json(LibraryUploadsResponseSchema, 'GET', '/storage/uploads'),
  remove: (folder: string, fileName: string) => empty('DELETE', `/storage/models?folder=${seg(folder)}&fileName=${seg(fileName)}`),
  install: (machineId: string, folder: string, fileName: string) =>
    json(DownloadResponseSchema, 'POST', `/machines/${seg(machineId)}/library-installs`, { folder, fileName }),
};

/** The archive of originals (doc 76). */
export const archiveApi = {
  archiveImage: (galleryId: string) => empty('POST', `/gallery/${seg(galleryId)}/archive`, {}),
  setMachineSwitch: (machineId: string, on: boolean) => empty('PUT', `/machines/${seg(machineId)}/archive`, { on }),
};

export const LIBRARY_KEY = ['library'] as const;
export const LIBRARY_UPLOADS_KEY = ['library-uploads'] as const;
